import {
  getDefaultFieldValue,
  getFieldValuesCloneWithoutErrorsForSection,
  mapErrorToFieldValues,
} from '../utils/formUtility'
import Joi from 'joi/lib/index'


export const getUpsertOnboardingImportDefaultFieldValues = () => ({
  walletAddress: getDefaultFieldValue(''),
  kycId: getDefaultFieldValue(''),
})

export const getUpsertOnboardingImportFieldValuesValidated = (fieldValues) => {
  let fieldValuesValidated = getFieldValuesCloneWithoutErrorsForSection(fieldValues)

  const schema = Joi.object().keys({
    walletAddress: Joi.string().label('Wallet address'),
    kycId: Joi.string().label('KYC/KYB ID'),
  })

  const result = schema.validate({
    walletAddress: fieldValues.walletAddress.value,
    kycId: fieldValues.kycId.value,
  }, { abortEarly: false })

  if (result.error) {
    fieldValuesValidated = mapErrorToFieldValues(
      fieldValuesValidated,
      result.error.details,
    )
  }

  return {
    isValid: !result.error,
    fieldValuesValidated,
  }
}

export const getUpsertOnboardingTargetRoleDefaultFieldValues = () => ({
  email: getDefaultFieldValue(''),
})

export const getUpsertOnboardingTargetRoleFieldValuesValidated = (fieldValues) => {
  let fieldValuesValidated = getFieldValuesCloneWithoutErrorsForSection(fieldValues)

  const schema = Joi.object().keys({
    email: Joi.string().optional().allow('').label('Email'),
  })

  const result = schema.validate({
    email: fieldValues.email.value,
  }, { abortEarly: false })

  if (result.error) {
    fieldValuesValidated = mapErrorToFieldValues(
      fieldValuesValidated,
      result.error.details,
    )
  }

  return {
    isValid: !result.error,
    fieldValuesValidated,
  }
}
